import { useEffect, useState } from "react";
import { API } from "../api/api";
import type { Session } from "../api/types";

export default function SessionsPage() {
  const [loading, setLoading] = useState(true);
  const [sessions, setSessions] = useState<Session[]>([]);

  useEffect(() => {
    async function load() {
      try {
        const res = await API.get("/api/sessions");

        // Backend might return:
        // 1) { ...session }  (single session object)
        // 2) { sessions: [...] } (future multi-session support)

        let list: Session[] = [];

        if (Array.isArray(res.data)) {
          list = res.data;
        } else if (Array.isArray(res.data.sessions)) {
          list = res.data.sessions;
        } else {
          list = [res.data];
        }

        setSessions(list);
      } finally {
        setLoading(false);
      }
    }

    load();
  }, []);

  if (loading) return <div>Loading sessions…</div>;

  return (
    <div style={{ padding: 20 }}>
      <h2>Active Sessions</h2>

      <table border={1} cellPadding={8} style={{ marginTop: 12 }}>
        <thead>
          <tr>
            <th>Session ID</th>
            <th>Client</th>
            <th>Platform</th>
            <th>Device ID</th>
            <th>IP Address</th>
            <th>Created</th>
            <th>Last Active</th>
          </tr>
        </thead>

        <tbody>
          {sessions.map((s) => (
            <tr key={s.session_id}>
              <td>{s.session_id}</td>
              <td>{s.client_id}</td>
              <td>{s.platform}</td>
              <td>{s.device_id}</td>
              <td>{s.ip_address}</td>
              <td>{new Date(s.created_at).toLocaleString()}</td>
              <td>{new Date(s.last_active_at).toLocaleString()}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}